import { render, staticRenderFns } from "./PageDetails.vue?vue&type=template&id=1fca9336"
import script from "./PageDetails.vue?vue&type=script&lang=js"
export * from "./PageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports